module.exports = __webpack_public_path__ + "img/file-plus.87af92b4.svg";